import Auth from "./General/Auth";
import Toast from "./General/Toast";
import Loader from "./General/Loader";
import ManageTag from "./General/ManageTag";

const reducers = { Toast, ManageTag, Auth, Loader };

export default reducers;
